import { FunctionComponent } from 'react';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { IPrimaryButtonProps } from './PrimaryButton.interface';

export const PrimaryButton: FunctionComponent<IPrimaryButtonProps> = (props) => {
  const {
    label,
    disabled,
    loading,
    startIcon,
    flexShrink = 0,
    onClick,
    disabledTooltip,
  } = props;

  if (disabledTooltip && disabled) {
    return (
      <Tooltip title={disabledTooltip}>
        <span>
          <Button
            startIcon={startIcon}
            disabled={disabled}
            onClick={onClick}
            sx={{ flexShrink }}
            loading={loading}
          >
            {label}
          </Button>
        </span>
      </Tooltip>
    );
  }

  return (
    <Button
      startIcon={startIcon}
      disabled={disabled}
      onClick={onClick}
      sx={{ flexShrink }}
      loading={loading}
    >
      {label}
    </Button>
  );
};
